import { useContext, useEffect, useState } from 'react';
import FastTrackOrders from '../components/FastTrackOrders/FastTrackOrder';
import TrackOrders from "../components/TrackOrders/TrackOrders";
import Thanks from '../components/Common/FinalResponse/Thanks';
import { GlobalContext } from '../context/GlobalContext';
import OrderStatus from "../components/TrackOrders/OrderStatus";
import RedownloadAttachments from '../components/FastTrackOrders/ReuploadDocuments/DownloadAttachments/RedownloadAttachments ';
import { leadInquiry } from '../api/api';
import { t } from 'i18next';
import ErrorModule from '../components/ErrorModule/ErrorModule'

const win: any = window;

const RouteComponent = () => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const { sourcePage, setQueryData, rtl } = state;
    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean | null>(null);
    const [urlParamsLoaded, setUrlParamsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const areQueryParamsValid = (params: Record<string, string | null>) => {
        return Object.values(params).every((val) => val && val.trim() !== '');
    }
    useEffect(() => {
        // http://localhost:3000/.digital.sales/react-app/build?extid=123&ctype=new&ptype=voice&unqid=20250701124010&otype=new
        const params = new URLSearchParams(window.location.search);
        const extid = params.get('extid');
        const ptype = params.get('ptype');
        const ctype = params.get('ctype');
        const unqid = params.get('unqid');
        const otype = params.get('otype');

        if (extid) localStorage.setItem('lead_exid', extid);
        if (ptype) localStorage.setItem('lead_ptype', ptype);
        if (ctype) localStorage.setItem('lead_ctype', ctype);
        if (unqid) localStorage.setItem('lead_unqid', unqid);
        if (otype) localStorage.setItem('lead_otype', otype);

        dispatch({
            type: 'SET_LEAD_PARAMS',
            payload: { extid, ptype, ctype, unqid, otype },
        });

        if (extid && ptype && ctype && unqid && otype) {
            dispatch({ type: 'LOADER', payload: { loading: true } });
            setTimeout(() => {
                dispatch({
                    type: 'SET_SOURCE_PAGE',
                    payload: 'rejectOrder',
                });
            }, 0);
        }
        setUrlParamsLoaded(true)

    }, [dispatch]);
    useEffect(() => {
        const fetchLeadInquiry = async () => {
            const extid = setQueryData.extid;
            const ctype = setQueryData.ctype;
            const ptype = setQueryData.ptype;
            const otype = setQueryData.otype;
            const unqid = setQueryData.unqid;
            if (!areQueryParamsValid({ extid, ctype, ptype, unqid, otype })) {
                setIsLoading(false);
                return;
            }
            try {
                const userType = ctype.toLowerCase() === 'new' ? 'newcustomer' : 'existingcustomer';
                dispatch({
                    type: 'SET_USER_TYPE',
                    payload: userType,
                });

                let productType = '';
                switch (ptype?.toLowerCase()) {
                    case 'voice':
                        productType = 'Voice';
                        break;
                    case 'data':
                        productType = 'Data';
                        break;
                    case 'sip':
                        productType = 'SIP';
                        break;
                    case 'fiber':
                        productType = 'Fiber';
                        break;
                    case 'fixed_internet':
                        productType = 'Fiber';
                        break;
                    default:
                        productType = 'Voice';
                }

                dispatch({
                    type: 'SET_PRODUCT_TYPE',
                    payload: productType,
                });
                const res: any = await leadInquiry(extid);
                if (res.status === 200) {
                    setIsFormSubmitted(true);
                }
                else if (res.status === 260) {
                    dispatch({
                        type: 'SET_SOURCE_PAGE',
                        payload: 'rejectOrder'
                    });
                }
                else {
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    document.location.href = "/wps/portal/web/personal/store/error"

                }
            }
            catch (err) {
                dispatch({ type: 'LOADER', payload: { loading: false } });
                document.location.href = "/wps/portal/web/personal/store/error"
            }
            finally {
                setIsLoading(false);
            }
        }
        if (urlParamsLoaded) {
            fetchLeadInquiry();
        }
    }, [setQueryData, urlParamsLoaded]);
    if (isLoading || !urlParamsLoaded) return null;
    const { extid, ptype, ctype, unqid, otype } = setQueryData;
    const validParams = areQueryParamsValid({ extid, ptype, ctype, unqid, otype });
    const handleFormSubmitted = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setIsFormSubmitted(false);
        document.body.style.overflow = 'auto';
        window.location = win['home_page_url'];
    }
    return (
        <>
            {isFormSubmitted ? (
                <ErrorModule
                    id={'otp_page_generic_error'}
                    rtl={rtl}
                    title={t('Sorry')}
                    description={t('link_is_no_longer')}
                    firstButtonText={t('got_it')}
                    modalFirstButtonClick={handleFormSubmitted}
                />
            ) : (urlParamsLoaded &&
                <>
                    {sourcePage === 'rejectOrder' && validParams && <RedownloadAttachments />}
                    {sourcePage === 'createOrder' && <FastTrackOrders />}
                    {sourcePage === 'trackOrder' && <TrackOrders />}
                    {sourcePage === 'thankYou' && <Thanks rtl={rtl} />}
                    {sourcePage === 'orderStatus' && <OrderStatus rtl={rtl} />}

                </>

            )}
        </>
    )
}
export default RouteComponent;